import React, { useEffect } from 'react';
import LeaseSummary from './components/LeaseSummary';

import { useLandaRouter } from '../../../hooks/logics/useLandaRouter';
import useSignLease, { SignLeaseProvider } from './context';
import SplitScreenComponent from '../../../components/containers/SplitScreenComponent';
import useAuth from '../../../context/Auth';
import PlaceOrderLogInSignup from '../../place-order/components/PlaceOrderLogInSignup';
import classNames from 'classnames';
import classes from './index.module.scss';
import SignUpFlow from '../../../components/generics/flows/LoginSignUpFlow/SignUpFlow';

const SignLeasePageInner = () => {
  const { router } = useLandaRouter();
  const { ticker, setTicker } = useSignLease();
  const { isLoggedIn } = useAuth();
  useEffect(() => {
    const { unitTicker } = router.query;
    if (unitTicker && ticker !== unitTicker.toString()) {
      setTicker(unitTicker.toString());
    }
  }, [router.query]);

  return (
    <SplitScreenComponent
      className={classes.container}
      LeftComponent={!isLoggedIn ? <SignUpFlow tenant={true} /> : <></>}
      RightComponent={<LeaseSummary />}
      leftContainerClassName={classNames(classes.leftSection)}
      leftContainerStyle={{ flex: !isLoggedIn ? 1 : 0 }}
      leftContentClassName={classes.leftContent}
      rightContentClassName={classes.rightContent}
      rightContainerClassName={classNames(classes.rightSection)}
    />
  );
};

const SignLeasePage = () => {
  return (
    <SignLeaseProvider>
      <SignLeasePageInner />
    </SignLeaseProvider>
  );
};

export default SignLeasePage;
